import { lazy, Suspense, useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustBand from "@/components/site/TrustBand";
import Highlights from "@/components/site/Highlights";
import Activities from "@/components/site/Activities";
import About from "@/components/site/About";
import Reviews from "@/components/site/Reviews";
import CtaBand from "@/components/site/CtaBand";
import PartnersTeaser from "@/components/site/PartnersTeaser";
import ContactBand from "@/components/site/ContactBand";
import Footer from "@/components/site/Footer";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";
import { useLanguage } from "@/context/LanguageContext";

export default function Home() {
  const { t, lang } = useLanguage();

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.title = t.meta.title;
    document.documentElement.lang = lang || "en";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", t.meta.description);
  }, [t, lang]);

  return (
    <div
      className="min-h-screen bg-[#FAF7F2] text-[#0A0A0A]"
      data-testid="home-page"
    >
      <Header />
      <main>
        <Hero />
        <TrustBand />
        <Highlights />
        <Activities />
        <PartnersTeaser />
        <About />
        <Reviews />
        <CtaBand />
        <ContactBand />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
